import { ofType } from "redux-observable";
import {
  switchMap,
  map,
  catchError,
  startWith,
  mergeMap,
  withLatestFrom,
} from "rxjs/operators";
import { of, interval, from } from "rxjs";
import {
  REDIRECT,
  GET_ALL_USERS,
  getAllUsersSuccessAction,
  getAllUsersErrorAction,
  SIGNIN,
  SIGNOUT,
  REFRESH_TOKEN,
  signInSuccessAction,
  signInErrorAction,
  refreshTokenSuccessAction,
  passwordRequiredChangeAction,
  CHANGE_PWD,
  changePasswordSuccessAction,
  changePasswordErrorAction,
} from "store/actions";
import { Auth } from "aws-amplify";

export const redirectEpic = (action$, _, { push }) =>
  action$.pipe(
    ofType(REDIRECT),
    switchMap(({ payload }) => of(push(payload)))
  );

export const getAllUsersEpic = (action$, _, { url, request }) =>
  action$.pipe(
    ofType(GET_ALL_USERS),
    switchMap(() =>
      request(`${url}/users`).pipe(
        map(({ response }) => getAllUsersSuccessAction(response)),
        catchError(() => of(getAllUsersErrorAction()))
      )
    )
  );

export const refreshTokenPollEpic = (action$, _, { config }) =>
  action$.pipe(
    ofType(REFRESH_TOKEN),
    switchMap(() =>
      interval(config.poll_refresh_timer_in_minutes * 60 * 1000).pipe(
        startWith(0),
        mergeMap(() => {
          return from(Auth.currentAuthenticatedUser()).pipe(
            mergeMap((user) => {
              const currentSession = user.signInUserSession;
              user.refreshSession(currentSession.refreshToken, (_, session) => {
                const congitoKey = window.localStorage.cognitoKey;
                const user = window.localStorage[`${congitoKey}.LastAuthUser`];
                //override localstorage values with new ones
                const { accessToken, refreshToken, idToken } = session;
                window.localStorage[`${congitoKey}.${user}.accessToken`] =
                  accessToken.jwtToken;

                window.localStorage[`${congitoKey}.${user}.refreshToken`] =
                  refreshToken.token;

                window.localStorage[`${congitoKey}.${user}.idToken`] =
                  idToken.jwtToken;

                console.log("Session token refreshed.");
              });
              return of(refreshTokenSuccessAction());
            })
          );
        })
      )
    )
  );

export const signInEpic = (action$, _, { push }) =>
  action$.pipe(
    ofType(SIGNIN),
    mergeMap(({ payload: { username, password } }) => {
      return from(Auth.signIn(username, password)).pipe(
        mergeMap((response) => {
          if (response.challengeName === "NEW_PASSWORD_REQUIRED") {
            return of(
              passwordRequiredChangeAction({ ...response, username, password })
            );
          }
          return of(signInSuccessAction(response), push("/"));
        }),
        catchError((error) => of(signInErrorAction(error)))
      );
    })
  );

export const signoutEpic = (action$, _, { push }) =>
  action$.pipe(
    ofType(SIGNOUT),
    switchMap(() => of(push("/")))
  );

export const changePasswordEpic = (action$, state$, { push }) =>
  action$.pipe(
    ofType(CHANGE_PWD),
    withLatestFrom(state$),
    mergeMap(
      ([
        {
          payload: { newPassword, newConfirmPassword },
        },
        {
          rootReducer: {
            core: {
              user: {
                userData: { username, password },
              },
            },
          },
        },
      ]) => {
        if (username === "" || password === "") {
          const error = {
            name: "AuthError",
            log: "An unknown error has ocurred",
          };
          return of(changePasswordErrorAction(error));
        }

        if (newPassword !== newConfirmPassword) {
          const error = {
            name: "AuthError",
            log: "Password(s) do not match",
          };
          return of(changePasswordErrorAction(error));
        }

        if (newPassword === "" || newConfirmPassword === "") {
          const error = {
            name: "AuthError",
            log: "Password(s) cannot be empty",
          };
          return of(changePasswordErrorAction(error));
        }
        /**
         * unfortunately due to storing the user returned from Auth.signIn
         * it loses some of it's typings, and this when we send it to
         * Auth.completeNewPassword it doesn't work, in this instance, we just
         * send the username and pwd again and take that user object instead
         */
        return from(Auth.signIn(username, password)).pipe(
          mergeMap((user) =>
            from(Auth.completeNewPassword(user, newPassword)).pipe(
              mergeMap((response) => {
                of(changePasswordSuccessAction(response), push("/"));
              }),
              catchError((error) => {
                return of(changePasswordErrorAction(error));
              })
            )
          )
        );
      }
    )
  );
